import type { components } from '../types/api/generated';
import { ffhClient } from '@lib/api/ffh-client';

export type TeamFixturesPreviewResponse =
  components['schemas']['TeamFixturesPreviewResponse'];
export type TeamWithFixturePreview =
  TeamFixturesPreviewResponse['data'][number];
export type TeamFixturePreview = TeamWithFixturePreview['fixtures'][number];

export type TeamFixturesPreviewParameters = {
  gameweekStart: number;
  gameweekEnd: number;
  // The endpoint defaults to the season of the current gameweek, but in the
  // off-season there is no current gameweek, so callers must name the upcoming
  // season explicitly to surface its fixtures.
  season?: number;
};

// Public endpoint backing the logged-out mini fixture ticker. It carries
// per-fixture difficulty only (no team strength, aggregates, or goal/clean-sheet
// predictions), so it is fetched without an access token.
export const fetchTeamFixturesPreview = async (
  parameters: TeamFixturesPreviewParameters
): Promise<TeamWithFixturePreview[]> => {
  const { data, error } = await ffhClient().GET(
    '/league/teams/fixtures-preview',
    {
      params: { query: parameters }
    }
  );

  if (error) throw new Error('Failed to load fixture preview');
  return data?.data ?? [];
};
